<template>
  <v-app>
    
    <Header></Header>
    
    <v-content>
      
        <router-view/>
      
    </v-content>

    <Footer></Footer>
  </v-app>
</template>

<script>
import Header from './components/common/Header'
import Footer from './components/common/Footer'


export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      //
    }
  }
}
</script>


<style>

  @font-face{
    font-family:'MetropolisBold';
    src: url("assets/fonts/Metropolis-Bold.otf")
  }

  @font-face{
    font-family:'MetropolisRegular';
    src: url("assets/fonts/Metropolis-Regular.otf")
  }

   @font-face{
    font-family:'MetropolisMedium';
    src: url("assets/fonts/Metropolis-Medium.otf")
  }

  @font-face{
    font-family:'MetropolisSemiBold';
    src: url("assets/fonts/Metropolis-SemiBold.otf")
  }

  html, 
  body,
  .application,
  p{
    /* font-family: MetropolisRegular, 'Arial'; */
    font-family: 'Montserrat', sans-serif;
  }

  .metropolisRegular{
    /* font-family: MetropolisRegular, 'Arial' !important; */
    font-family: 'Montserrat', sans-serif;
  }

  .metropolisMedium{
    /* font-family: MetropolisMedium, 'Arial' !important; */
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 500 !important;
  }

  .metropolisSemiBold{
    /* font-family: MetropolisSemiBold, 'Arial' !important; */
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 600 !important;
  }

  .metropolisBold{
    /* font-family: MetropolisBold, 'Arial' !important; */
    font-family: 'Montserrat', sans-serif !important;
    font-weight:700 !important;
  }

  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6{
    /* font-family: MetropolisBold, 'Arial' !important; */
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 700 !important;
  }

  

  .blueBanner{
    background-color:#172583;
    color:#FFF;
  }

  .v-toolbar{
    background-color:#FFF;
    box-shadow:none;
  }

  .textCenter{
    text-align:center
  }
  
  
</style>

